import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  totalElements: 0,
  totalPages: 0,
  error: "",
}

export const postSlice = createSlice({
  name: "post",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // find-all
      .addCase(findAllPost.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(findAllPost.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.data = action.payload.page
        state.totalElements = action.payload.totalElements
        state.totalPages = action.payload.totalPages
      })
      .addCase(findAllPost.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })

      // save
      .addCase(savePost.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(savePost.fulfilled, (state, action) => {
        state.status = "succeeded"
        let data = [...state.data]
        data = data.map((item) =>
          item.post.id === action.payload.id
            ? { ...item, post: action.payload }
            : item
        )
        state.data = data
      })
      .addCase(savePost.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })

      // delete
      .addCase(deletePost.pending, (state, _) => {
        state.status = "loading"
      })
      .addCase(deletePost.fulfilled, (state, action) => {
        state.status = "succeeded"
        let data = [...state.data]
        data = data.filter((item) => item.post.id !== action.payload.id)
        state.data = data
      })
      .addCase(deletePost.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const findAllPost = createAsyncThunk(
  "/post/find-all",
  async (
    {
      start = 0,
      limit = 75,
      postType = 1,
      title = "%",
      user = "%",
      state = 1,
      jwt,
    },
    thunkAPI
  ) => {
    try {
      const endpoint = `/post/console?start=${start}&limit=${limit}&post-type=${postType}&title=%25${title}%25&user=${user}&state=${state}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const savePost = createAsyncThunk(
  "/post/save",
  async ({ post, jwt }, thunkAPI) => {
    try {
      // esto no se por que demonios pasa, pero a la api llega con un dia menos
      // por eso se escriben las siguientes lineas
      const startDate = moment(post.startDate)
        .add(1, "day")
        .format("YYYY-MM-DD")
      const finishDate = moment(post.finishDate)
        .add(1, "day")
        .format("YYYY-MM-DD")
      console.log(startDate)
      console.log(finishDate)

      const endpoint = `/post`
      const { data } = await axios.post(
        API_ROUTE + endpoint,
        {
          ...post,
          startDate,
          finishDate,
        },
        {
          headers: { Authorization: jwt },
        }
      )
      return thunkAPI.fulfillWithValue(data)
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const deletePost = createAsyncThunk(
  "/post/delete",
  async ({ id, jwt }, thunkAPI) => {
    try {
      const endpoint = `/post/${id}`
      await axios.delete(API_ROUTE + endpoint, {
        headers: { Authorization: jwt },
      })
      return thunkAPI.fulfillWithValue({ id })
    } catch (ex) {
      console.log(ex)
      return thunkAPI.rejectWithValue(ex.message)
    }
  }
)

export const getPost = (state) => state.post
export default postSlice.reducer
